import { MemberDatasource } from '../../global/datasources/member_datasource';
import { ICommand, IQuery, IDefineCommand } from 'core-ts-types';

// hack to make GainSightPX global without clobbering the function
// tslint:disable-next-line
let aptrinsic: any;

angular.module('capability-ng-user-app').factory(
  'initializeAnonymousUserActivityCommand',
  (ngMemberDatasource: MemberDatasource, defineCommand: IDefineCommand): ICommand => {
    return defineCommand('initializeAnonymousUserActivityCommand', function initializeAnonymousUserActivityCommand(
      deferred: ng.IDeferred<IQuery[]>
    ): void {
      try {
        const member = ngMemberDatasource.read().core_config;
        const userActivity = {
          visitor: {},
          account: {
            member: member.full_name,
            name: member.full_name,
            id: location.hostname,
            version_ui: '1.2.0',
            version_api: '1'
          }
        };

        if ('aptrinsic' in window && _.isFunction(window['aptrinsic'])) {
          (window as any)['aptrinsic']('identify', userActivity.visitor, userActivity.account);
        }
      } finally {
        deferred.resolve();
      }
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/initialize_anonymous_user_activity_command.ts